export default "__VITE_ASSET__IRfYvyJY__";